export var Admin;
(function (Admin) {
    /**
     * Add roles to a shared workspace
     *
     * @export
     * @class AddRolesToSharedWorkspace
     * @implements {EvaService}
     */
    class AddRolesToSharedWorkspace {
        name = 'Admin:AddRolesToSharedWorkspace';
        path = '/message/AddRolesToSharedWorkspace';
        request;
        response;
    }
    Admin.AddRolesToSharedWorkspace = AddRolesToSharedWorkspace;
    /**
     * Create a new Module
     *
     * @export
     * @class AdminCreateModule
     * @implements {EvaService}
     */
    class AdminCreateModule {
        name = 'Admin:AdminCreateModule';
        path = '/message/AdminCreateModule';
        request;
        response;
    }
    Admin.AdminCreateModule = AdminCreateModule;
    /**
     * Delete a Module
     *
     * @export
     * @class AdminDeleteModule
     * @implements {EvaService}
     */
    class AdminDeleteModule {
        name = 'Admin:AdminDeleteModule';
        path = '/message/AdminDeleteModule';
        request;
        response;
    }
    Admin.AdminDeleteModule = AdminDeleteModule;
    /**
     * Gives a list of all admin modules visible by the current user.
     *
     * @export
     * @class AdminGetAllModules
     * @implements {EvaService}
     */
    class AdminGetAllModules {
        name = 'Admin:AdminGetAllModules';
        path = '/message/AdminGetAllModules';
        request;
        response;
    }
    Admin.AdminGetAllModules = AdminGetAllModules;
    /**
     * Gives a list of all roles that are allowed to see this module
     *
     * @export
     * @class AdminGetModuleAllowedRoles
     * @implements {EvaService}
     */
    class AdminGetModuleAllowedRoles {
        name = 'Admin:AdminGetModuleAllowedRoles';
        path = '/message/AdminGetModuleAllowedRoles';
        request;
        response;
    }
    Admin.AdminGetModuleAllowedRoles = AdminGetModuleAllowedRoles;
    /**
     * Get a Module by ID
     *
     * @export
     * @class AdminGetModuleByID
     * @implements {EvaService}
     */
    class AdminGetModuleByID {
        name = 'Admin:AdminGetModuleByID';
        path = '/message/AdminGetModuleByID';
        request;
        response;
    }
    Admin.AdminGetModuleByID = AdminGetModuleByID;
    /**
     * Gives a list of all modules that the given role isallowed to see
     *
     * @export
     * @class AdminGetRoleAllowedModules
     * @implements {EvaService}
     */
    class AdminGetRoleAllowedModules {
        name = 'Admin:AdminGetRoleAllowedModules';
        path = '/message/AdminGetRoleAllowedModules';
        request;
        response;
    }
    Admin.AdminGetRoleAllowedModules = AdminGetRoleAllowedModules;
    /**
     * List the Modules
     *
     * @export
     * @class AdminListModules
     * @implements {EvaService}
     */
    class AdminListModules {
        name = 'Admin:AdminListModules';
        path = '/message/AdminListModules';
        request;
        response;
    }
    Admin.AdminListModules = AdminListModules;
    /**
     * Update an existing Module
     *
     * @export
     * @class AdminUpdateModule
     * @implements {EvaService}
     */
    class AdminUpdateModule {
        name = 'Admin:AdminUpdateModule';
        path = '/message/AdminUpdateModule';
        request;
        response;
    }
    Admin.AdminUpdateModule = AdminUpdateModule;
    /**
     * Set which roles are allowed to see the specified module. Will replace existing values.
     *
     * @export
     * @class AdminUpdateModuleAllowedRoles
     * @implements {EvaService}
     */
    class AdminUpdateModuleAllowedRoles {
        name = 'Admin:AdminUpdateModuleAllowedRoles';
        path = '/message/AdminUpdateModuleAllowedRoles';
        request;
        response;
    }
    Admin.AdminUpdateModuleAllowedRoles = AdminUpdateModuleAllowedRoles;
    /**
     * Set which modules are allowed to see by the specified role. Will replace existing values.
     *
     * @export
     * @class AdminUpdateRoleAllowedModules
     * @implements {EvaService}
     */
    class AdminUpdateRoleAllowedModules {
        name = 'Admin:AdminUpdateRoleAllowedModules';
        path = '/message/AdminUpdateRoleAllowedModules';
        request;
        response;
    }
    Admin.AdminUpdateRoleAllowedModules = AdminUpdateRoleAllowedModules;
    /**
     * Creates a new shared workspace.
     *
     * @export
     * @class CreateSharedWorkspace
     * @implements {EvaService}
     */
    class CreateSharedWorkspace {
        name = 'Admin:CreateSharedWorkspace';
        path = '/message/CreateSharedWorkspace';
        request;
        response;
    }
    Admin.CreateSharedWorkspace = CreateSharedWorkspace;
    /**
     * Creates a new workspace for the current user.
     *
     * @export
     * @class CreateWorkspace
     * @implements {EvaService}
     */
    class CreateWorkspace {
        name = 'Admin:CreateWorkspace';
        path = '/message/CreateWorkspace';
        request;
        response;
    }
    Admin.CreateWorkspace = CreateWorkspace;
    /**
     * Delete a shared workspace by it's ID
     *
     * @export
     * @class DeleteSharedWorkspace
     * @implements {EvaService}
     */
    class DeleteSharedWorkspace {
        name = 'Admin:DeleteSharedWorkspace';
        path = '/message/DeleteSharedWorkspace';
        request;
        response;
    }
    Admin.DeleteSharedWorkspace = DeleteSharedWorkspace;
    /**
     * Delete a Workspace by it's ID
     *
     * @export
     * @class DeleteWorkspace
     * @implements {EvaService}
     */
    class DeleteWorkspace {
        name = 'Admin:DeleteWorkspace';
        path = '/message/DeleteWorkspace';
        request;
        response;
    }
    Admin.DeleteWorkspace = DeleteWorkspace;
    /**
     * Get a shared workspace by ID
     *
     * @export
     * @class GetSharedWorkspaceByID
     * @implements {EvaService}
     */
    class GetSharedWorkspaceByID {
        name = 'Admin:GetSharedWorkspaceByID';
        path = '/message/GetSharedWorkspaceByID';
        request;
        response;
    }
    Admin.GetSharedWorkspaceByID = GetSharedWorkspaceByID;
    /**
     * Get a workspace by ID
     *
     * @export
     * @class GetWorkspaceByID
     * @implements {EvaService}
     */
    class GetWorkspaceByID {
        name = 'Admin:GetWorkspaceByID';
        path = '/message/GetWorkspaceByID';
        request;
        response;
    }
    Admin.GetWorkspaceByID = GetWorkspaceByID;
    /**
     * Get all workspaces for the current user
     *
     * @export
     * @class GetWorkspaces
     * @implements {EvaService}
     */
    class GetWorkspaces {
        name = 'Admin:GetWorkspaces';
        path = '/message/GetWorkspaces';
        request;
        response;
    }
    Admin.GetWorkspaces = GetWorkspaces;
    /**
     * List all shared workspaces based on the given filter
     *
     * @export
     * @class ListSharedWorkspaces
     * @implements {EvaService}
     */
    class ListSharedWorkspaces {
        name = 'Admin:ListSharedWorkspaces';
        path = '/message/ListSharedWorkspaces';
        request;
        response;
    }
    Admin.ListSharedWorkspaces = ListSharedWorkspaces;
    /**
     * Remove (all) roles from a workspace
     *
     * @export
     * @class RemoveRolesFromSharedWorkspace
     * @implements {EvaService}
     */
    class RemoveRolesFromSharedWorkspace {
        name = 'Admin:RemoveRolesFromSharedWorkspace';
        path = '/message/RemoveRolesFromSharedWorkspace';
        request;
        response;
    }
    Admin.RemoveRolesFromSharedWorkspace = RemoveRolesFromSharedWorkspace;
    /**
     * Set active workspace for the current user
     *
     * @export
     * @class SetActiveWorkspace
     * @implements {EvaService}
     */
    class SetActiveWorkspace {
        name = 'Admin:SetActiveWorkspace';
        path = '/message/SetActiveWorkspace';
        request;
        response;
    }
    Admin.SetActiveWorkspace = SetActiveWorkspace;
    /**
     * Set default shared workspace for roles
     *
     * @export
     * @class SetDefaultSharedWorkspaceForRoles
     * @implements {EvaService}
     */
    class SetDefaultSharedWorkspaceForRoles {
        name = 'Admin:SetDefaultSharedWorkspaceForRoles';
        path = '/message/SetDefaultSharedWorkspaceForRoles';
        request;
        response;
    }
    Admin.SetDefaultSharedWorkspaceForRoles = SetDefaultSharedWorkspaceForRoles;
    /**
     * Transfer shared wordspace ownership with ID and optional user Update
     *
     * @export
     * @class TransferSharedWorkspaceOwnership
     * @implements {EvaService}
     */
    class TransferSharedWorkspaceOwnership {
        name = 'Admin:TransferSharedWorkspaceOwnership';
        path = '/message/TransferSharedWorkspaceOwnership';
        request;
        response;
    }
    Admin.TransferSharedWorkspaceOwnership = TransferSharedWorkspaceOwnership;
    /**
     * Update a shared workspace by ID
     *
     * @export
     * @class UpdateSharedWorkspace
     * @implements {EvaService}
     */
    class UpdateSharedWorkspace {
        name = 'Admin:UpdateSharedWorkspace';
        path = '/message/UpdateSharedWorkspace';
        request;
        response;
    }
    Admin.UpdateSharedWorkspace = UpdateSharedWorkspace;
    /**
     * Update a workspace by ID
     *
     * @export
     * @class UpdateWorkspace
     * @implements {EvaService}
     */
    class UpdateWorkspace {
        name = 'Admin:UpdateWorkspace';
        path = '/message/UpdateWorkspace';
        request;
        response;
    }
    Admin.UpdateWorkspace = UpdateWorkspace;
})(Admin || (Admin = {}));
//# sourceMappingURL=EVA.Admin.Services.js.map